<template>
    <div id="main">
        <!-- <loader v-if="isLoading"/> -->
        <alert-container :messages="msgs" />
        <div class="page">
            <div class="tipos-servicos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('criticas-despesas') }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a>{{ $t('despesas') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'des-critica-despesa' })">
                                        {{ $t('criticas-despesas') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('possivel-check-invalido') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="!isSaving"
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'des-critica-despesa' })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="!isSaving && permissao.update"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="updateReplicaPda()"
                        >
                            {{ $t('salvar') }}
                        </button>
                    </div>
                </div>

                <div class="registry-wrapper">
                    <empty-table-message v-if="isEmpty" />
                    <b-table v-else :data="criticasDespesas" class="data-table" backend-sorting>
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="$t(f.key)"
                            :width="f.width"
                            :sortable="false"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'nome'" :title="props.row.idcheck">
                                {{ props.row[f.key] }}
                            </div>
                            <div v-else-if="f.key == 'mensagem'" v-html="props.row[f.key]"></div>
                            <div v-else-if="f.key == 'observacao'">
                                {{ props.row[f.key] }}
                            </div>
                            <div v-else-if="f.key == 'data'">
                                <span v-if="props.row[f.key] != null">
                                    {{ props.row[f.key] | moment('L LT') }}
                                </span>
                                <span v-else>---</span>
                            </div>
                            <div v-else-if="f.key == 'origem'">
                                {{ $t(props.row[f.key]) }}
                            </div>
                            <div
                                v-else-if="f.key == 'mapa' && permissao.update"
                                class="has-text-centered"
                            >
                                <span
                                    @click="openLocationEditor(props.row)"
                                    v-tippy
                                    :title="$t('editar-coordenada')"
                                >
                                    <b-icon
                                        class="map-marker"
                                        pack="fas"
                                        icon="map-marker-alt"
                                        size="is-medium"
                                        :type="
                                            props.row.observacao != 'coordenada-editada'
                                                ? 'is-primary'
                                                : 'is-success'
                                        "
                                    />
                                </span>
                            </div>
                        </b-table-column>
                    </b-table>
                </div>

                <MapasGoogleMapsModal
                    v-if="permissao.update"
                    :center="center"
                    :isUpdating="isUpdatingClient"
                    :locationEditorOpen="locationEditorOpen"
                    :update="true"
                    @updateLocation="updateLocation"
                    @onCancelLocationEditor="onCancelLocationEditor"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CriticasDespesasService from '@/services/despesas/CriticasDespesasService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import GoogleMaps from '@/components/shared/maps/MapasGoogleMaps';
import Message from '@/models/Message';
import MapasGoogleMapsModal from '@/components/shared/maps/MapasGoogleMapsModal';
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService';
import ClienteService from '@/services/vendas/cliente/ClienteService';
import ProClienteService from '@/services/promotor/ClienteService';
import ProLpsService from '@/services/promotor/ProLpsService';

export default {
    components: {
        ContainerLoader,
        GoogleMaps,
        MapasGoogleMapsModal,
    },
    data() {
        return {
            debouncedOnSearch: null,
            criticasDespesas: [],
            service: new CriticasDespesasService(this.$http, this.$router),
            serviceUsuario: new GerenciarUsuariosService(this.$http, this.$router),
            serviceCliente: new ClienteService(this.$http, this.$router),
            serviceProCliente: new ProClienteService(this.$http, this.$router),
            serviceLps: new ProLpsService(this.$http, this.$router),
            fields: [
                { key: 'nome', width: null },
                { key: 'mensagem', width: null },
                { key: 'data', width: 140 },
                { key: 'mapa', width: 70 },
            ],
            isLoading: false,
            isSaving: false,
            isEmpty: false,
            column: 'cliente',
            order: 'asc',
            permissao: {},
            center: {
                lat: null,
                lng: null,
            },
            locationEditorOpen: false,
            cancelLocationEditor: false,
            isUpdatingClient: false,
            msgs: [],
            checkin: null,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'despesas',
            'criticas-despesas',
            'criticas-despesas'
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'criticas-despesas' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.getLocation, 1000);
        }
    },
    methods: {
        openLocationEditor(checkin) {
            this.center.lat = +checkin.latitudecheckin;
            this.center.lng = +checkin.longitudecheckin;
            this.checkin = checkin;
            this.locationEditorOpen = true;
        },
        onCancelLocationEditor() {
            this.locationEditorOpen = false;
            this.center.lat = 0;
            this.center.lng = 0;
            this.checkin = null;
        },
        updateLocation(val) {
            this.isLoading = true;
            this.isSaving = true;
            this.checkin.latitudecheckin = val.center.lat;
            this.checkin.longitudecheckin = val.center.lng;

            if (this.checkin.origem == 'usuario') {
                this.updateCoordenadaUsuario();
            } else if (this.checkin.origem == 'procliente') {
                this.updateCoordenadaProCliente();
            } else if (this.checkin.origem == 'cliente') {
                this.updateCoordenadaCliente();
            } else if (this.checkin.origem == 'prolps') {
                this.updateCoordenadaProLps();
            } else {
                this.updateCoordenadaCheckin();
            }
        },
        updateCoordenadaUsuario() {
            let form = {
                latitude: this.checkin.latitudecheckin,
                longitude: this.checkin.longitudecheckin,
                idusuario: this.$route.params.id,
            };

            this.serviceUsuario
                .updateLocation(form)
                .then((value) => {
                    if (value.status == 200) {
                        this.checkin.observacao = 'coordenada-editada';
                        this.checkin.mensagem = this.$t('coordenada-editada-n', 
                            { n: this.$t(this.checkin.origem) }
                        );
                        this.msgs.push(
                            new Message('success', 'msg-coordenada-editada-sucesso', true)
                        );

                        this.onCancelLocationEditor();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                    this.checkin = null;
                });
        },
        updateCoordenadaProCliente() {
            let form = {
                idcliente: this.checkin.procliente.idcliente,
                latitude: this.checkin.latitudecheckin,
                longitude: this.checkin.longitudecheckin,
            };
            this.serviceProCliente
                .updateLocation(form)
                .then((value) => {
                    if (value.status == 200) {
                        this.checkin.observacao = 'coordenada-editada';
                        this.checkin.mensagem = this.$t('coordenada-editada-n', 
                            { n: this.$t(this.checkin.origem) }
                        );
                        this.msgs.push(
                            new Message('success', 'msg-coordenada-editada-sucesso', true)
                        );

                        this.onCancelLocationEditor();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                    this.checkin = null;
                });
        },
        updateCoordenadaCliente() {
            let form = {
                idcliente: this.checkin.cliente.idcliente,
                latitude: this.checkin.latitudecheckin,
                longitude: this.checkin.longitudecheckin,
            };
            this.serviceCliente
                .updateLocation(form)
                .then((value) => {
                    if (value.status == 200) {
                        this.checkin.observacao = 'coordenada-editada';
                        this.checkin.mensagem = this.$t('coordenada-editada-n', 
                            { n: this.$t(this.checkin.origem) }
                        );
                        this.msgs.push(
                            new Message('success', 'msg-coordenada-editada-sucesso', true)
                        );

                        this.onCancelLocationEditor();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                    this.checkin = null;
                });
        },
        updateCoordenadaProLps() {
            let form = {
                idlps: this.checkin.prolps.idlps,
                latitude: this.checkin.latitudecheckin,
                longitude: this.checkin.longitudecheckin,
            };
            this.serviceLps
                .updateLocation(form)
                .then((value) => {
                    if (value.status == 200) {
                        this.checkin.observacao = 'coordenada-editada';
                        this.checkin.mensagem = this.$t('coordenada-editada-n', 
                            { n: this.$t(this.checkin.origem) }
                        );
                        this.msgs.push(
                            new Message('success', 'msg-coordenada-editada-sucesso', true)
                        );

                        this.onCancelLocationEditor();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                    this.checkin = null;
                });
        },
        updateCoordenadaCheckin() {
            let form = {
                latitudecheckin: this.checkin.latitudecheckin,
                longitudecheckin: this.checkin.longitudecheckin,
                idcheck: this.checkin.idcheck,
            };
            this.service
                .updateLocation(form)
                .then((value) => {
                    if (value.status == 200) {
                        this.checkin.observacao = 'coordenada-editada';
                        this.checkin.mensagem = this.$t('coordenada-editada-n', 
                            { n: this.$t(this.checkin.origem) }
                        );
                        this.msgs.push(
                            new Message('success', 'msg-coordenada-editada-sucesso', true)
                        );

                        this.onCancelLocationEditor();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                    this.checkin = null;
                });
        },
        carregarDados() {
            this.isLoading = true;
            this.service
                .findAllById(this.$route.params.id, this.$route.params.data)
                .then(this.mapItems)
                .then((value) => {
                    if (value.length > 0) {
                        /* Dependendo da descrição da crítica que vier vai duplicar o registro, 
                        como no caso onde o erro pode estar na coordenada da casa do vendedor e em cliente */
                        let count = 0;
                        value.forEach((check) => {
                            if (check.observacao.includes('usuario') && count == 0) {
                                let temp = Object.assign({}, check);
                                temp.data = null;
                                temp.origem = 'usuario';
                                temp.nome = check.usuario.nome;
                                temp.latitudecheckin = check.usuario.latitude;
                                temp.longitudecheckin = check.usuario.longitude;
                                temp.mensagem = this.$t('possivel-localizacao-invalida-n', 
                                    { n: this.$t(temp.origem) }
                                );

                                this.criticasDespesas.push(temp);
                            }
                            // colocar procliente em primeiro para não cair sempre em cliente
                            if (check.observacao.includes('procliente')) {
                                let temp = Object.assign({}, check);
                                temp.origem = 'procliente';
                                temp.nome = check.procliente.nome;
                                temp.latitudecheckin = check.procliente.latitude;
                                temp.longitudecheckin = check.procliente.longitude;
                                temp.mensagem = this.$t('possivel-localizacao-invalida-n', 
                                    { n: this.$t(temp.origem) }
                                );

                                this.criticasDespesas.push(temp);
                            } else if (check.observacao.includes('cliente')) {
                                let temp = Object.assign({}, check);
                                temp.origem = 'cliente';
                                temp.nome = check.cliente.nome;
                                temp.latitudecheckin = check.cliente.latitude;
                                temp.longitudecheckin = check.cliente.longitude;
                                temp.mensagem = this.$t('possivel-localizacao-invalida-n', 
                                    { n: this.$t(temp.origem) }
                                );

                                this.criticasDespesas.push(temp);
                            } else if (check.observacao.includes('prolps')) {
                                let temp = Object.assign({}, check);
                                temp.origem = 'prolps';
                                temp.nome = check.prolps.nome;
                                temp.latitudecheckin = check.prolps.latitude;
                                temp.longitudecheckin = check.prolps.longitude;
                                temp.mensagem = this.$t('possivel-localizacao-invalida-n', 
                                    { n: this.$t(temp.origem) }
                                );

                                this.criticasDespesas.push(temp);
                            } else {
                                let temp = Object.assign({}, check);
                                temp.origem = 'checkin';
                                if (temp.cliente) {
                                    temp.nome = check.cliente.nome;
                                } else if (temp.procliente) {
                                    temp.nome = check.procliente.nome;
                                } else if (temp.prolps) {
                                    temp.nome = check.prolps.nome;
                                }
                                temp.mensagem = this.$t('possivel-localizacao-invalida-n', 
                                    { n: this.$t(temp.origem) }
                                );

                                this.criticasDespesas.push(temp);
                            }
                            count++;
                        });
                    }
                    this.isEmpty = this.criticasDespesas.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            return body.content.map((m) => {
                return {
                    idcheck: m.idcheck,
                    usuario: m.usuario,
                    cliente: m.cliente,
                    procliente: m.procliente,
                    prolps: m.prolps,
                    data: m.checkindatahora,
                    latitudecheckin: m.latitudecheckin,
                    longitudecheckin: m.longitudecheckin,
                    observacao: m.observacao,
                    mensagem: null,
                };
            });
        },
        updateReplicaPda() {
            if (!this.criticasDespesas.filter((f) => f.observacao.includes('invalida')).length) {
                let redirect = false;
                this.isLoading = true;
                this.isSaving = true;
                this.service
                    .updateReplicaPda(this.$route.params.id, this.$route.params.data)
                    .then((value) => {
                        if (value.status == 200) {
                            redirect = true;
                            this.redirectToList();
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        if (!redirect) {
                            this.isSaving = false;
                            this.isLoading = false;
                        }
                    });
            } else {
                this.msgs.push(new Message('alert', 'alert-gerado-criticas', true));
            }
        },
        redirectToList() {
            setTimeout(() => this.$router.push({ name: 'des-critica-despesa' }), 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;
    }
    .map-marker:hover {
        cursor: pointer;
        opacity: 0.5;
    }
    .remove-linha-coluna {
        display: none !important;
    }
}
</style>
